import { NotesScreen } from '@/features/notes/components/notes-screen';

export function NotesPage() {
  return <NotesScreen />;
}
